import * as storage from 'src/lib/storage';
import { isNotProduction } from 'src/lib/url';

/**
 * Feature flag for displaying brief debug data
 * Visible when storage item exists or not in production environment
 */
export const BRIEF_DEBUG_DATA_VISIBLE: boolean =
  storage.readItem('feature.briefDebugDataVisible') != null ||
  isNotProduction(window.location.href);

/**
 * Feature flag for enabling AC prompt debugging
 * Enabled when storage item exists
 */
export const DEBUG_AC_PROMPT_ENABLED: boolean =
  storage.readItem('feature.debugAcPromptEnabled') != null;

/**
 * Backend "customer" features flags
 * Maps feature flag names to their corresponding backend identifiers
 * @see /post-malone/backend/app/models/flipper_feature.rb
 */
export const BE_CUSTOMER_FEATURES = {
  hebrewSupport: 'hebrew_support',
  blogResearchGivenUrl: 'blog_research_given_url',
  blogResearchWebSearch: 'blog_research_web_search',
  blogSeoScore: 'blog_seo_score',
  personalizePrompt: 'personalize_prompt',
  twitterSocialIntegrationEnabled: 'twitter_social_integration_enabled',
  imageGenerationOld: 'image_generation', // TODO: disabled for all on production, we should remove everything that is behind this FF
  supportImageGeneration: 'support_image_generation', // TODO: enabled for all on production, we should drop FF and open related logic by default
  blogFactsStatsQuotes: 'blog_facts_stats_quotes',
  salesforceCrmIntegrationEnabled: 'salesforce_crm_integration_enabled',
  publishIntegrationsEnabled: 'publish_integrations_enabled',
  sprinklrIntegrationEnabled: 'sprinklr_integration_enabled',
  performanceChartEnabled: 'performance_chart_enabled',
  audioVideoResourcesEnabled: 'audio_video_resources_enabled',
  apInsightsEnabled: 'ap_insights_enabled',
  integrationsReAuthEnabled: 'integrations_reauth_enabled',
  userReportExport: 'user_report_export',
  userReportView: 'user_report_view',
  supportSfAiChat: 'support_sf_ai_chat',

  // Deprecated flags, keep for not accidentally reusing, because we might have Flipper gates for them on BE
  // directS3FileUpload: 'direct_s3_file_upload',
  // eloquaIntegrationEnabled: 'eloqua_integration_enabled',
  // twitterAdsCustomModeImport: 'twitter_ads_custom_mode_import',
  // googleAdsCustomModeImport: 'google_ads_custom_mode_import',
  // landingPageBuilderProject: 'landing_page_builder_project',
  // getScoreInlineFunction: 'get_score_inline_function',
  // websiteIntelligence: 'website_intelligence',
  // blogFromUrl: 'blog_from_url',
  // infinityExtension: 'infinity_extension',
} as const;
export type BackendCustomerFeature =
  (typeof BE_CUSTOMER_FEATURES)[keyof typeof BE_CUSTOMER_FEATURES];

/**
 * Backend "user" features configuration
 * Maps feature flag names to their corresponding backend identifiers
 */
export const BE_USER_FEATURES = {
  superAdminUser: 'super_admin_user',
  // Deprecated flags, keep for not accidentally reusing, because we might have Flipper gates for them on BE
  // customTemplatesFromReviews: 'custom_templates_from_reviews',
} as const;
export type BackendUserFeature = (typeof BE_USER_FEATURES)[keyof typeof BE_USER_FEATURES];
